/** AI condition assessment statuses that need ops/manual follow-up (KAN-212). */
export const AI_MANUAL_REVIEW_STATUSES = Object.freeze([
  "analysis_failed",
  "pending_manual_review",
]);

export function isAiManualReviewStatus(statusOrAi) {
  const status =
    typeof statusOrAi === "string"
      ? statusOrAi
      : statusOrAi?.status;
  return AI_MANUAL_REVIEW_STATUSES.includes(status);
}

/**
 * User-facing copy when automated vision did not complete successfully.
 * Returns null when the assessment finished normally (analyzed / clear).
 */
export function inspectionAiStatusBanner(ai = {}) {
  if (ai.status === "analysis_failed") {
    return {
      title: "Temporary service glitch",
      body:
        "We apologize! The service has a temporary glitch; please try again in a moment. "
        + "Your photos were saved — this does not mean the vehicle is undamaged; "
        + "ops may review them manually.",
    };
  }
  if (ai.status === "pending_manual_review") {
    return {
      title: "Manual review may follow",
      body:
        "We apologize! The service has a temporary glitch; please try again in a moment. "
        + "Your photos were saved — our team may review them manually.",
    };
  }
  return null;
}
